import React from 'react'
import { useTranslation } from 'react-i18next'
import { Tag as TagAnt } from 'antd'

import { Roles } from 'src/types'

type RoleProps = Roles | 'QUOTING' | 'REQUESTER' | 'TRAVELER'

interface Props {
  role: RoleProps
}

function getColor(role: RoleProps) {
  switch (role.toUpperCase()) {
    case 'APPROVER':
    case 'TRAVELER':
      return 'blue'
    case 'CHECKER':
    case 'CONTROLLER':
    case 'MANAGER':
      return 'geekblue'
    case 'REQUESTER':
      return 'green'
    case 'QUOTING':
      return 'orange'
  }
}

function TagRole({ role }: Props) {
  const { t } = useTranslation()
  return (
    <TagAnt color={getColor(role)}>
      {t(`web.table.roles.${role}`.toLowerCase())}
    </TagAnt>
  )
}

export default TagRole
